function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouseNew = function SvgHouseNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.26 48H30.28c-.41 0-.75-.34-.75-.75V33.88H18.48v13.37c0 .41-.34.75-.75.75H6.74c-.41 0-.75-.34-.75-.75V26.03H.95c-.19 0-.38-.06-.53-.16a.9.9 0 0 1-.34-.43.942.942 0 0 1 .21-1.03L23.48 1.99c.29-.28.75-.28 1.04 0l8.93 8.63v-2.6c0-.41.34-.75.75-.75h7.06c.41 0 .75.34.75.75V18.9l5.7 5.51c.14.14.22.3.26.47.04.2.02.39-.05.56-.07.18-.19.33-.35.43-.15.1-.34.16-.53.16h-5.03v21.22c0 .41-.34.75-.75.75Zm-10.23-1.5h9.48V25.28c0-.41.34-.75.75-.75h4.42l-4.94-4.78a.741.741 0 0 1-.23-.54V8.77h-5.56v3.62c0 .3-.18.57-.46.69s-.6.06-.81-.15L24 3.57 2.32 24.53h4.42c.41 0 .75.34.75.75V46.5h9.49V33.13c0-.41.34-.75.75-.75h12.55c.41 0 .75.34.75.75V46.5Zm15.63-21.03Zm.38-.94h.01-.01Z",
    style: {
      fill: "#00a550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h48v48H0z"
  })));
};
export default SvgHouseNew;